export default "__VITE_ASSET__Ck1E91tf__"